import React from "react";

interface Props {
  className?: string;
}

export const BuildingsIcon = ({ className = "" }: Props): JSX.Element => {
  return (
<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path d="M9.33333 13.4333H9.43333V13.3333V5.33329C9.43333 3.91785 10.5846 2.76663 12 2.76663H25.3333C26.7488 2.76663 27.9 3.91785 27.9 5.33329V28C27.9 28.3271 27.7701 28.6408 27.5388 28.8721C27.3075 29.1034 26.9938 29.2333 26.6667 29.2333H5.33333C5.00623 29.2333 4.69253 29.1034 4.46124 28.8721C4.22994 28.6408 4.1 28.3271 4.1 28V16C4.1 14.5845 5.25123 13.4333 6.66667 13.4333H9.33333ZM6.66667 15.9H6.56667V16V26.6666V26.7666H6.66667H14.6667H14.7667V26.6666V16V15.9H14.6667H6.66667ZM25.3333 26.7666H25.4333V26.6666V5.33329V5.23329H25.3333H12H11.9V5.33329V13.3333V13.4333H12H14.6667C16.0821 13.4333 17.2333 14.5845 17.2333 16V26.6666V26.7666H17.3333H25.3333Z" fill="white" stroke="#1890FF" strokeWidth="0.2"/>
    <path d="M14.7667 8.1H17.2334V10.5667H14.7667V8.1ZM20.1 8.1H22.5667V10.5667H20.1V8.1ZM20.1 13.4747H22.5667V15.9H20.1V13.4747ZM20.1 18.7667H22.5667V21.2333H20.1V18.7667ZM9.43337 18.768H11.9V21.2347H9.43337V18.768Z" fill="white" stroke="#1890FF" strokeWidth="0.2"/>
</svg>
  );
};
